import { StoreState } from "../types/index";
import { query } from "./query";
import { results } from "./results";
import { ui } from "./ui";
import { columns } from "./columns";

import { combineReducers } from "redux";

export function passThrough(
  state: StoreState.Config,
  action: any,
): StoreState.Config {
  if (state === undefined) {
    state = {docsPath: '', apiPath: ''};
  }
  return state;
}

const rootReducer = combineReducers<StoreState.All>({
  query,
  results,
  ui,
  columns,
  config: passThrough,
});

export default rootReducer;
